// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34KES","right":"styles_right__3N4Bh"};